var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#0096B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.24 21.86C24.35 22.36 23.33 22.64 22.24 22.64C21.15 22.64 20.13 22.36 19.24 21.86C16.18 23.06 14 26.04 14 29.53V29.88C16.2 31.82 19.08 32.9901 22.24 32.9901C25.4 32.9901 28.28 31.8201 30.48 29.8701V29.52C30.48 26.04 28.3 23.06 25.24 21.86ZM22.24 11C19.24 11 16.81 13.4301 16.81 16.4301C16.81 19.4301 19.24 21.86 22.24 21.86C25.24 21.86 27.67 19.4301 27.67 16.4301C27.66 13.4301 25.24 11 22.24 11Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.de311edd57719cdf76e3d3401dfdf966.svg";
export { ForwardRef as ReactComponent };